import React from 'react';

import Loader from 'utils/Loader';
import { BASE_URL } from 'Service/ApiService';
import { Typography, Box } from '../../../node_modules/@mui/material/index';
import SalesOrderUploadController from 'pages/Controller/SalesOrderUploadController';

function SalesOrderUpload() {
  const { loading, handleFileChange, handleUpload, fileInputRef } = SalesOrderUploadController();

  const handleDownload = () => {
    window.location.href = BASE_URL + 'uploads/sample_sales_order.csv';
  };

  return (
    <div className="center-container">
      {loading && (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Please wait...</span>
        </div>
      )}
      <div className="white-box">
        <h2 style={{ fontWeight: 'medium', textAlign: 'center' }}>Sales Order Upload</h2>
        <div style={{ marginTop: '10px', marginBottom: '10px', float: 'right' }}>
          <button className="sample-download-button" onClick={handleDownload}>
            Sample CSV
          </button>
        </div>
        <div style={{ marginTop: '10px' }}>
          <form onSubmit={handleUpload}>
            <div style={{ marginBottom: '20px' }}>
              <label htmlFor="fileInput" style={{ fontWeight: 'bold', fontSize: '0.75rem', display: 'block', marginBottom: '4px' }}>
                Select File
              </label>
              <input type="file" id="fileInput" onChange={handleFileChange} ref={fileInputRef} className="upload-input" accept=".csv" />
            </div>

            {/* {alert &&
            <div style={{ textAlign: 'left', marginBottom: '10px' }}>
              <span style={{color:`${severity}`}}>{message}</span>
            </div>
          } */}

            <Box p={2}>
              <Typography variant="overline" display="block" color="#770000E6">
                <strong>Required Field -</strong> partyCode, mCatID, VTWEG, materialCode, materialDesc, chart, shade, grade, materialSize,
                qty, remarks, OrderReason, DelDate
              </Typography>
            </Box>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button className="soft-button" type="submit" disabled={loading}>
                UPLOAD
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SalesOrderUpload;
